module.exports = __webpack_public_path__ + "static/img/auntLogo.ec53368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auntLogo.png
// module id = N5DG
// module chunks = 19